export const DEFAULT_TOAST_MESSAGE = 'Erro genérico';
export const TOAST_TITLE = 'Notificação';
export const SEARCH_PLACEHOLDER = 'Pesquisar...';
export const DIGITE_PLACEHOLDER = 'Digite';
export const SELECT_PLACEHOLDER = 'Selecione';
export const SYSTEM_GENERATED_PLACEHOLDER = 'Gerado pelo sistema';
export const REQUIRED_MESSAGE = 'Campo obrigatório.';
export const EMAIL_INVALID_MESSAGE = 'Digite um e-mail válido.';
